export default __webpack_public_path__ + "static/media/Classwin_Menu-pop-up_6-Report.6b6e46ee.jpeg";